export class ForeignEntry {
    constructor(value, strValue) {
        this.value = value ? value : -1;
        this.strValue = strValue ? strValue : '';
    }
}
